import CryptoJS from 'crypto-js'

// AES加密配置 - 可在此处自定义密钥和IV
// 密钥和IV必须是16字节（128位）、24字节（192位）或32字节（256位）
const AES_KEY = 'K8#mPq$RnT2@vYsW'; // AES加密密钥（16字节）
const AES_IV = 'Za%Xd*CfV5&bGtH7'; // AES加密IV（16字节）

export default {
    install(Vue) {
		/**
		 * 新窗口打开路由页面
		 * @path 地址
		 * @param 参数
		 */
		Vue.prototype.openPage = function(path, param) {
			let routeUrl = this.$router.resolve({
				  path: path,
				  query: param
			 });
			 window.open(routeUrl.href, '_blank');
		},
		
		/**
		 * 打开路由页面
		 * @path 地址
		 * @query 参数
		 */
		Vue.prototype.goToPage = function(path, query={}) {
			this.$router.push({
				path,
				query
			});
		},
		
		/**
		 * 上传图片文件统一验证
		 * @file 文件
		 * @size 大小，默认2M
		 */
		Vue.prototype.beforeAvatarUploadCommon = function (file, size = 2) {
		  const FileExt = file.name.replace(/.+\./, "");
		  const is2M = file.size / 1024 / 1024 < size;
		  if (
		      ["jpg", "png", "gif"].indexOf(FileExt.toLowerCase()) === -1 ||
		      !is2M
		  ) {
		    this.$message({
		      type: "warning",
		      message: `请上传 jpg|png|gif 图像，大小不超过${size}MB`
		    });
		    return false;
		  }else{
			  return true;
		  }
		},
		
		/**
		 * 将时间戳改为日期显示
		 * @timestamp 时间戳
		 * @status 是否显示时分秒，默认不显示
		 */
		Vue.prototype.timestampConvertDate = function(timestamp, status=false) {
			// 创建一个新的 Date() 对象并传入时间戳作为参数
			var dateObj = new Date(timestamp);
			// 获取年、月、日等信息
			var year = dateObj.getFullYear(); // 年份
			var month = dateObj.getMonth() + 1; // 月份（注意要加上1）
			var day = dateObj.getDate(); // 日期
			var hours = dateObj.getHours(); // 小时
			var minutes = dateObj.getMinutes(); // 分钟
			var seconds = dateObj.getSeconds(); // 秒钟
			return status ? year + "-" + month + "-" + day +' '+hours + ":" + minutes + ":" + seconds : year + "-" + month + "-" + day;
		},
		
		// 将附件转为base64
		Vue.prototype.dataURLtoFileBase64 = function(event, fn) {
			var event = event || window.event;
			    var file = event.target.files[0];
			    var reader = new FileReader();
			    //转base64
			    reader.onload = function(e) {
					fn && fn(e.target.result); //将图片路径赋值给src 
			    }
			    reader.readAsDataURL(file);
		},
		
		/**
		 * 密码加密（使用AES加密）
		 * @password 原始密码
		 * @customKey 自定义密钥（可选，不传则使用默认配置）
		 * @customIV 自定义IV（可选，不传则使用默认配置）
		 * @return 加密后的密码
		 */
		Vue.prototype.encryptPassword = function(password, customKey, customIV) {
			if (!password) return '';
			// 使用自定义密钥和IV，如果没有传入则使用默认配置
			let keyStr = customKey || AES_KEY;
			let ivStr = customIV || AES_IV;
			// 确保密钥和IV长度为16字节（AES-128）
			// 如果长度不足16字节，用'0'填充；如果超过16字节，截取前16字节
			keyStr = keyStr.substring(0, 16);
			ivStr = ivStr.substring(0, 16);
			while (keyStr.length < 16) {
				keyStr += '0';
			}
			while (ivStr.length < 16) {
				ivStr += '0';
			}
			const key = CryptoJS.enc.Utf8.parse(keyStr);
			const iv = CryptoJS.enc.Utf8.parse(ivStr);
			// 使用 AES-CBC 模式加密密码
			const encrypted = CryptoJS.AES.encrypt(
				CryptoJS.enc.Utf8.parse(password),
				key,
				{
					iv: iv,
					mode: CryptoJS.mode.CBC,
					padding: CryptoJS.pad.Pkcs7
				}
			);
			return encrypted.toString();
		}
		
    }
}